<template>
  <div id="noti_anim_root" style="position: fixed; top: 50px; right: 10px; z-index: 3;">
    <div style="position: relative">
      <cake-animation
        v-show="type === ANIMATION_TYPES.CAKE"
        ref="cake_animation"
        :amount="displayNotification.amount"
        :notification="displayNotification.msg"
      />
      <crown-animation
        v-show="type === ANIMATION_TYPES.CROWN"
        ref="crown_animation"
        :amount="displayNotification.amount"
        :notification="displayNotification.msg"
      />
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import { mapGetters } from 'vuex';
import { NotificationMixin } from '../../mixins/notification';
import CakeAnimation from './animations/CakeAnimation';
import CrownAnimation from './animations/CrownAnimation';
import Vue from 'vue';

export default {
  components: { CrownAnimation, CakeAnimation },
  mixins: [component, NotificationMixin],

  data() {
    return {
      type: -1,
      isShowingAnimation: false,
      displayNotification: {
        amount: 0,
        notification: '',
      },
    };
  },
  computed: {
    ...mapGetters('notifications', ['notificationsAnimation']),
  },
  watch: {
    notificationsAnimation: function(newVal, oldVal) {
      Vue.nextTick(() => {
        if (newVal.length > 0 && !this.isShowingAnimation) {
          this.showAnimation();
        }
      });
    },
  },
  methods: {
    showAnimation() {
      const notification = this.notificationsAnimation[0];

      this.type = notification.type;
      this.displayNotification = notification;
      this.isShowingAnimation = true;

      if (this.type === this.ANIMATION_TYPES.CAKE) {
        this.$refs.cake_animation.playAnimation(this.removeAnimation);
      } else if (this.type === this.ANIMATION_TYPES.CROWN) {
        this.$refs.crown_animation.playAnimation(this.removeAnimation);
      }
    },
    removeAnimation() {
      this.isShowingAnimation = false;
      const notification = this.displayNotification.msg;
      this.displayNotification = {
        amount: 0,
        msg: '',
      };
      this.$store.dispatch('notifications/removeNotificationAnimation', notification);
    },
  },
};
</script>
